/**
 * <complete-the-look>
 * Horizontal scroll-snap carousel with previous / next arrows.
 * Arrows are only shown when the products overflow the track, and each one is
 * disabled once the track reaches that end.
 */
class CompleteTheLook extends HTMLElement {
  /** @type {HTMLElement | null} */
  #track = null;
  /** @type {HTMLButtonElement | null} */
  #prev = null;
  /** @type {HTMLButtonElement | null} */
  #next = null;
  /** @type {ResizeObserver | null} */
  #resizeObserver = null;

  connectedCallback() {
    this.#track = this.querySelector('[data-track]');
    this.#prev = this.querySelector('[data-prev]');
    this.#next = this.querySelector('[data-next]');

    if (!this.#track) return;

    this.#prev?.addEventListener('click', () => this.#scrollByItem(-1));
    this.#next?.addEventListener('click', () => this.#scrollByItem(1));
    this.#track.addEventListener('scroll', () => this.#update(), { passive: true });

    this.#resizeObserver = new ResizeObserver(() => this.#update());
    this.#resizeObserver.observe(this.#track);
    this.#update();
  }

  disconnectedCallback() {
    this.#resizeObserver?.disconnect();
    this.#resizeObserver = null;
  }

  /** @param {number} direction 1 for next, -1 for previous */
  #scrollByItem(direction) {
    const track = this.#track;
    if (!track) return;

    const item = track.querySelector('li');
    const gap = parseFloat(getComputedStyle(track).columnGap) || 0;
    const step = item ? item.getBoundingClientRect().width + gap : track.clientWidth;
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    track.scrollBy({ left: step * direction, behavior: reducedMotion ? 'auto' : 'smooth' });
  }

  #update() {
    const track = this.#track;
    if (!track) return;

    const maxScroll = track.scrollWidth - track.clientWidth - 1;
    const overflowing = maxScroll > 0;

    this.toggleAttribute('data-overflowing', overflowing);
    if (this.#prev) this.#prev.disabled = track.scrollLeft <= 0;
    if (this.#next) this.#next.disabled = track.scrollLeft >= maxScroll;
  }
}

if (!customElements.get('complete-the-look')) {
  customElements.define('complete-the-look', CompleteTheLook);
}
